'use strict';

import angular from 'angular';

function GroupAttributeResource($resource) {
  // id = personId;
  return $resource('/api/groups/:groupId/groupattributes/:id/:controller', {
    id: '@id'
  }, {
    set: { method: 'PUT' }
  });
}

GroupAttributeResource.$inject = ['$resource'];

export default angular.module('georgeApp.groupAttributeSvc', [])
  .factory('GrpAtrSvc', GroupAttributeResource)
  .name;
